import Swiper from 'swiper/bundle'

window.customElements.define('hero-multi-banner', class HeroMultiBanner extends HTMLElement {
  constructor() {
    super()

    const autoScroll = this.dataset.autoScroll === 'true'
    const autoScrollSpeed = parseInt(this.dataset.autoScrollSpeed, 10) * 1000

    const slideCount = this.querySelectorAll('.swiper-slide').length

    const config = {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      breakpoints: {
        768: { spaceBetween: 32 },
      },
      loop: slideCount > 1,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      autoplay: autoScroll ? {
        delay: autoScrollSpeed,
        disableOnInteraction: false,
      } : false,
    }

    let swiper = new Swiper(this.querySelector('.swiper-container'), config)

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', () => {
        swiper = new Swiper(this.querySelector('.swiper-container'), config)
      })

      document.addEventListener('shopify:section:unload', () => { swiper.destroy() })

      document.addEventListener('shopify:block:select', (evt) => {
        if (!this.contains(evt.target)) return
        const index = Array.prototype.indexOf.call(evt.target.parentNode.children, evt.target)
        if (config.loop) {
          swiper.slideToLoop(index)
        } else {
          swiper.slideTo(index)
        }
      })
    }
  }
})
